export default __webpack_public_path__ + "static/media/icon-collection-light.2d5e5fb5.svg";